import { Injectable } from '@angular/core';
import { initializeFaro, getWebInstrumentations, Faro, MetaUser } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import jwtDecode from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class FaroSdkService {

    public faroSdk: Faro;

    /**
     * Event to start FaroSdk Service
     * @param configData
     */
    StartFaroSdk(configData: any): void {
		this.faroSdk = initializeFaro({
			url: configData.api.faroSdk,
			app: {
				name: configData.version.appName,
				version: configData.version.tag,
				environment: configData.version.environment,
			},
			instrumentations: [
				...getWebInstrumentations({
					captureConsole: true,
					enablePerformanceInstrumentation: true
				}),
				new TracingInstrumentation(),
			],
		});
    }

    /**
     * Event to set user data in FaroSdk
     * @param token
     */
    public setUser(token: any): void {
        const userInfo: any = jwtDecode(token);
        const user: MetaUser = {
            email: userInfo.email,
            fullName: `${userInfo.first_name} ${userInfo.last_name}`,
            username: userInfo.name,
            roles: userInfo.roles
        }

        this.faroSdk.api.setUser(user);
    }
}
